export default {
  reports: [
    { key: "reports.balanceSheet", link: "/reports/balance-sheet" },
    { key: "reports.balanceSheetYTDSummary", link: "/reports/balance-sheet-ytd-summary" },
    { key: "reports.trialBalance", link: "/reports/trial-balance" },
    { key: "reports.accountScheduleConsolidation", link: "/reports/account-schedule-consolidation" },
    { key: "reports.arAgingDiscrepancy", link: "/reports/ar-aging-discrepancy" },
    { key: "reports.apAgingDiscrepancy", link: "/reports/ap-aging-discrepancy" },
    { key: "reports.bankAccountAgingDiscrepancy", link: "/reports/bank-account-aging-discrepancy" },
    { key: "reports.profitAndLoss", link: "/reports/profit-and-loss" },
    { key: "reports.profitAndLossCurrentMonthConsolidation", link: "/reports/profit-and-loss/consolidation/current-month" },
    { key: "reports.profitAndLossYTDConsolidation", link: "/reports/profit-and-loss/consolidation/ytd" },
    { key: "reports.profitAndLossYTDSummary", link: "/reports/profit-and-loss/summary/ytd" },
    { key: "reports.cashFlow", link: "/reports/cash-flow" },
    { key: "reports.cashFlowYTDSummary", link: "/reports/cash-flow/summary/ytd" },
    { key: "reports.cashFlowByDepartment", link: "/reports/cash-flow-by-department" },
    { key: "reports.accountPayableAging", link: "/reports/account-payable-aging" },
    { key: "reports.accountPayableInterimAging", link: "/reports/account-payable-interim-aging" },
    { key: "reports.accountPayablePaymentList", link: "/reports/account-payable-payment-list" },
    { key: "reports.accountReceivableAging", link: "/reports/account-receivable-aging" },
    { key: "reports.accountReceivableAgingCard", link: "/reports/card-aging" },
    { key: "reports.arAgingCardAndLedger", link: "/reports/account-receivable-aging-card-ledger" },
    { key: "reports.accountReceivablePaymentList", link: "/reports/account-receivable-payment-list" },
    { key: "reports.accountReceivablePaymentListCard", link: "/reports/account-receivable-payment-list-card" },
    { key: "reports.accountReceivablePaymentListLedger", link: "/reports/account-receivable-payment-list-ledger" },
    { key: "reports.inventoryAccountBalanceDetail", link: "/reports/inventory-account-balance-detail" },
    { key: "reports.slowMovingInventory", link: "/reports/slow-moving-inventory" },
    { key: "reports.stockOnHand", link: "/reports/stock-on-hand" },
    { key: "reports.topPurchaseItem", link: "/reports/top-purchase-item" },
    { key: "reports.dailyFlashCost", link: "/reports/daily-flash-cost" },
    { key: "reports.itemExpense", link: "/reports/item-expense" },
    { key: "reports.receivingReport", link: "/reports/purchase-receiving" },
    { key: "reports.inventoryReconciliation", link: "/reports/inventory-reconciliation" },
    { key: "reports.itemReorder", link: "/reports/item-reorder" },
    { key: "reports.topPurchaseByVendor", link: "/reports/top-purchase-by-vendor" },
    { key: "reports.outstandingPurchaseOrder", link: "/reports/outstanding-purchase-order" },
    { key: "reports.forceClosedPurchaseOrder", link: "/reports/force-closed-purchase-order" },
    { key: "reports.inventoryMovementReport", link: "/reports/inventory-movement" },
    { key: "reports.itemConsumptionReport", link: "/reports/item-consumption" },
  ]
};

